import {IFetchContext} from "@pg-mono/data-fetcher";
import {IVendorDetailActiveOffersParams} from "@pg-mono/rp-routes/src/types/IVendorDetailActiveOffersParams";

import {rpApi} from "../../app/api/rp_api";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IAppDispatch} from "../../store/store";
import {getVendorDetailOfferListMap} from "../api/get_vendor_detail_offer_list_map";
import {getVendorDetailOffers} from "../api/get_vendor_detail_offers";
import {convertToVendorDetailViewOffersPayload} from "../utils/convert_to_vendor_detail_view_offers_payload";

export const vendorOfferDetailViewAction = (ctx: IFetchContext<IRPRequestMeta, IVendorDetailActiveOffersParams>) => async (dispatch: IAppDispatch) => {
    const {vendorId} = ctx.match.params;

    const fullQuery = {
        ...convertToVendorDetailViewOffersPayload({vendorId: parseInt(vendorId), region: null, displayType: OfferDisplayType.FOR_SALE}),
        page: 1
    };

    await dispatch(getVendorDetailOffers.endpoints.getVendorDetailOffers.initiate(fullQuery));
    await dispatch(getVendorDetailOfferListMap.endpoints.getVendorDetailOfferListMap.initiate({vendor: parseInt(vendorId)}));

    await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));
};
import {IFetchContext} from "@pg-mono/data-fetcher";
import {IVendorDetailActiveOffersParams} from "@pg-mono/rp-routes/src/types/IVendorDetailActiveOffersParams";

import {rpApi} from "../../app/api/rp_api";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IAppDispatch} from "../../store/store";
import {getVendorDetailOfferListMap} from "../api/get_vendor_detail_offer_list_map";
import {getVendorDetailOffers} from "../api/get_vendor_detail_offers";
import {convertToVendorDetailViewOffersPayload} from "../utils/convert_to_vendor_detail_view_offers_payload";

export const vendorOfferDetailViewAction = (ctx: IFetchContext<IRPRequestMeta, IVendorDetailActiveOffersParams>) => async (dispatch: IAppDispatch) => {
    const {vendorId} = ctx.match.params;

    const fullQuery = {
        ...convertToVendorDetailViewOffersPayload({vendorId: parseInt(vendorId), region: null, displayType: OfferDisplayType.FOR_SALE}),
        page: 1
    };

    await dispatch(getVendorDetailOffers.endpoints.getVendorDetailOffers.initiate(fullQuery));
    await dispatch(getVendorDetailOfferListMap.endpoints.getVendorDetailOfferListMap.initiate({vendor: parseInt(vendorId)}));

    await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));
};
